import { Collapse } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
`;

export const StyledCollapse = styled(Collapse)`
  border-radius: 0px;
  border: none;
  background-color: transparent;

  .ant-collapse-item {
    overflow: hidden;
    margin-bottom: 16px;
    border-bottom: none;
    border-radius: 8px;

    &:last-child {
      .ant-collapse-header {
        border-radius: 8px;
      }
    }

    &.ant-collapse-item-active {
      .ant-collapse-header {
        border-radius: 8px 8px 0 0;
      }
    }

    .ant-collapse-header {
      background: ${COLOR_OPTIONS.BLUE_70};
      color: ${COLOR_OPTIONS.NEUTRAL_00};
      font-weight: 600;
      font-size: 16px;
      align-items: center;
      display: flex;
      padding: 2px 16px;
      line-height: 24px;

      .ant-collapse-expand-icon {
        .ant-collapse-arrow {
          font-size: 24px;
          animation: ${rotate} 0.3s ease-in-out forwards;
        }
      }
    }

    .ant-collapse-panel {
      border: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
      border-radius: 0 0 8px 8px;
      overflow: hidden;

      > .ant-collapse-body {
        padding: 0;
      }
    }
  }

  .ant-table {
    .ant-table-container {
      .ant-table-content {
        .ant-table-thead {
          > tr {
            > th {
              background: ${COLOR_OPTIONS.NEUTRAL_20};
              border-bottom: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};

              &:first-child,
              &:last-child {
                border-radius: 0;
              }

              &:before {
                display: none;
              }
            }
          }
        }

        .ant-table-row {
          &:nth-child(even) {
            background: ${COLOR_OPTIONS.NEUTRAL_10};
            border-bottom: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
          }

          &:hover:not(:nth-child(even)) {
            background: ${COLOR_OPTIONS.NEUTRAL_00};
          }

          > td {
            background: transparent;
            padding: 8px 16px;
          }
        }
      }
    }
  }
`;

export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const StyledHeaderTitle = styled.span`
  color: ${COLOR_OPTIONS.NEUTRAL_00};
`;

export const StyledHeaderEditButton = styled.div`
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;
